import { useState, useCallback } from 'react';

import '../../Styles/ArtistRoot.css';
import logo_white from "../../assets/logotipo_white.png";

import { Outlet, Link} from 'react-router-dom';


import UserContextProvider from '../../Context/UserContext';
export default function ArtistLanding(){
    const isImpersonating = localStorage.getItem('impersonating') === 'true';
    const impersonatingName = localStorage.getItem('impersonating_name') || '';

    const stopImpersonation = useCallback(() => {
        // Restore admin session
        localStorage.setItem('token', localStorage.getItem('admin_backup_token'));
        localStorage.setItem('type', localStorage.getItem('admin_backup_type'));
        localStorage.setItem('id', localStorage.getItem('admin_backup_id'));
        localStorage.setItem('name', localStorage.getItem('admin_backup_name'));
        localStorage.setItem('user', localStorage.getItem('admin_backup_user'));
        // Clean up
        localStorage.removeItem('admin_backup_token');
        localStorage.removeItem('admin_backup_type');
        localStorage.removeItem('admin_backup_id');
        localStorage.removeItem('admin_backup_name');
        localStorage.removeItem('admin_backup_user');
        localStorage.removeItem('impersonating');
        localStorage.removeItem('impersonating_name');
        window.location.href = '/artists-list';
    }, []);

    return (
            <UserContextProvider>
                <div className="">
                    {isImpersonating && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
                            background: 'linear-gradient(90deg, #f59e0b, #d97706)',
                            color: '#fff', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', gap: 16, padding: '8px 16px',
                            fontSize: 14, fontWeight: 600, boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                        }}>
                            <span>A ver como: <strong>{impersonatingName}</strong></span>
                            <button onClick={stopImpersonation} style={{
                                background: '#fff', color: '#d97706', border: 'none',
                                borderRadius: 6, padding: '4px 14px', fontWeight: 700,
                                cursor: 'pointer', fontSize: 13
                            }}>
                                Voltar ao Admin
                            </button>
                        </div>
                    )}
                    <header class="blue-bg inset-x-0 top-0 z-50" style={isImpersonating ? { marginTop: 42 } : {}}>
                        <nav class="flex w-items-center w-2xl justify-between p-6 " aria-label="Global">
                            <div class="flex lg:flex-1">
                                <a href="#" class="-m-1.5 p-1.5 flex">
                                    <img class="h-8 w-auto" src={logo_white} alt=""/>
                                </a>
                            </div>
                            <div class="lg:flex lg:flex-1 items-center gap-5 lg:justify-end">
                                <Link to={"/upload"}>
                                    <span class="text-gray-100">Carregar música</span>
                                </Link>
                                <Link to="/home" class="leading-6 text-gray-100">
                                    <span class="text-gray-100">Home</span>
                                </Link>
                                {!isImpersonating && (
                                    <button onClick={()=>{
                                        localStorage.clear();
                                            window.location.reload();
                                        }}>
                                        <span class="text-gray-100">Sair</span>
                                    </button>
                                )}
                            </div>
                        </nav>
                    </header>
                    <div className='w-full bg-white flex-1'>
                        <Outlet/>
                    </div>

                </div>
            </UserContextProvider>
            );


}
